

























































import {Component, Vue, Prop, Watch, Emit, VModel, PropSync, Ref} from 'vue-property-decorator';

@Component({})
export default class Autocomplete extends Vue {

    @VModel() innerValue: any;
    
    @Prop() items!: Array<any>;
    @Prop() label!: string;
    @Prop() loading!: boolean;
    @Prop() itemText!: string;
    @Prop() itemValue!: string;
    @Prop() placeholder!: string;
    @Prop({ default: true }) enabled!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop() readonly!: boolean;
    @Prop() rules!: [ any[] ];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: false }) noFilter!: boolean;
    @Prop() searchInputSync!: string;

    @Ref() autocomplete!: any;

    @Watch("selectedItems")
    tenantIdChanged (v: any) {
        let newValue: Array<any> = [];
        v.forEach((e: any) => {
            newValue.push(e[this.itemValue]);
        });
        this.innerValue = newValue;

        this.updateSelectedText();
    }

    @Watch("search")
    searchChanged (v: string, p: string) {
        this.$emit("search", v);
    }

    selectedText = "";
    selectedItems = [];
    search = "";

    created() {
        this.updateSelectedText();
    }

    blur () {
        this.autocomplete.blur();
    }

    getSelectedText(item: any) {
      if (this.selectedItems && this.selectedItems.length === 1) {
        return item[this.itemText];
      } else if (this.selectedItems) {
        const firstItemName = this.selectedItems[0][this.itemText];
        return `${firstItemName}`;
      }
    }

    updateSelectedText() {
      if (this.selectedItems.length > 0) {
        this.selectedText = this.getSelectedText(this.selectedItems[0]);
      } else {
        this.selectedText = '';
      }
    }

}
